// This file is auto-generated. Do not edit!

export default [
  {
    id: "0xac0f906e433d58fa868f936e8a43230473652885",
    name: "Genesis",
    description:
      "This is the vault for the StakeWise V2 pool. After migrating from StakeWise V2 to V3, you will be staking in this vault. The validators in this vault are run by StakeWise Labs.",
  },
  {
    id: "0xe6d8d8ac54461b1c5ed15740eee322043f696c08",
    name: "Chorus One Max Vault",
    description:
      "Chorus One’s ground-breaking MEV research ensures the highest yields with top-tier security and enterprise-level infrastructure. Start staking ETH today.",
  },
  {
    id: "0xb266274f55e784689e97b7e363b0666d92e6305b",
    name: "NodeSet Private Vault",
    description:
      "A vault for private users. Powered by NodeSet's uniquely decentralized infrastructure network.",
  },
  {
    id: "0x663a8c9e88c5cdc565cc4bf0b2bec8d862d744a6",
    name: "CCM GigaVault",
    description: "CCM is the name, staking is the game",
  },
  {
    id: "0x47fd7ac6c6bc73f2d419a18d0692f37df3f48034",
    name: "Stakin Private Vault 1",
    description: null,
  },
  {
    id: "0x15639e82d2072fa510e5d2b5f0db361c823bcad3",
    name: "0x15639e82d2072fa510e5d2b5f0db361c823bcad3",
    description: null,
  },
  {
    id: "0x34284c27a2304132af751b0dec5bba2cf98ed039",
    name: "0x34284c27a2304132af751b0dec5bba2cf98ed039",
    description: null,
  },
  {
    id: "0xb36fc5e542cb4fc562a624912f55da2758998113",
    name: "Serenita - Powered by Vero",
    description:
      "Serenita provides enterprise-grade staking services with a focus on top-tier performance and minimal risk. Our exclusive focus is on the Ethereum ecosystem and we are dedicated to its long-term sustainability and neutrality.\n\nThe validators in this Vault are powered by Vero, our custom-built multi-node validator client software. Similar to DVT technology, Vero verifies the chain’s latest state across multiple independent client implementations—shielding our validators from single-client bugs and downtime.\n\nFor a deeper understanding of our operational approach, visit our website at serenita.io",
  },
  {
    id: "0x1b3ce55dde0e0d4b9a200855406e7b14334c10b0",
    name: "Allnodes",
    description:
      "Reliable non-custodial Validator run by the industry leader - Allnodes",
  },
  {
    id: "0xa8cb2e35f594b308726b242136f0a8995bf19e97",
    name: "Easy Stake - Powered by SSV",
    description:
      "3 out of 4 Fault Tolerance  - SSV Operators 491, 770, 1002, 1003 - Solo node runner since April 2023 -   Nethermind/Nimbus, Reth/Lighthouse, Geth/Prysm, Besu/Lodestar - MEV enabled - High-end NUC with UPS",
  },
  {
    id: "0xb144b3b2d2a7d82e53bc70659be03bcd21cd94e8",
    name: "CCM TokenVault",
    description: "CCM is the name, tokenized staking is the game",
  },
  {
    id: "0x4425bb38d4ca95e522f9308175ec7d8188e8284e",
    name: "Dream vault",
    description:
      "This is a private vault and accumulating ETH for a home node runner from family and friends",
  },
  {
    id: "0x663580b3edad914d0b59cea88616f06278d42bb2",
    name: "onchainaustria.at",
    description:
      "onchainaustria is the first Austrian DAO-directed association (𓃵 Airdrop incoming!). We operate as a node operator (ETH, STRK, UNI) with low fees and a highly redundant infrastructure.\n\nWe are a thriving Austrian crypto community, dedicated to enabling our members to participate in and support the decentralization of DLT networks.\n\nJoin us and become part of a collaborative environment driving the future of decentralization!\n\n🔗 onchainaustria.at",
  },
  {
    id: "0x579ecfe4270ce23589d8b0a41dd234316018c11c",
    name: "0x579ecfe4270ce23589d8b0a41dd234316018c11c",
    description: null,
  },
  {
    id: "0x8a93a876912c9f03f88bc9114847cf5b63c89f56",
    name: "Stakingverse - Max MEV Boost",
    description:
      "Welcome to The Stakingverse!\n\nA premier staking provider with competitive fees, MEV boost and state-of-the-art infrastructure.\n\nAs an official StakeWise partner, we are dedicated to perfecting the secure and decentralized nature of the V3 Protocol to multiple chains. And with a team of highly-experienced professionals, who have been on the front-line of blockchain technology for many years now, you will get the best service, APY and security in liquid staking.\n\nStake your LYX and ETH with The Best at stakingverse.io",
  },
  {
    id: "0x8216e50b1dd76faeb1ff4cafaba6790ea71910df",
    name: "Data Nexus",
    description:
      "Independent Ethereum validators with owned hardware, MEV boost, and minority clients for robust decentralization. Empowering the Ethereum network with integrity.",
  },
  {
    id: "0xb1e3ca426d3a3810edb58017a4d6a71fc6221f44",
    name: "CCM LeverVault",
    description: "CCM Is the name, levered staking is the game",
  },
  {
    id: "0x99510bfc5d420cd3c41458f4692b1c3321908734",
    name: "Stakely",
    description:
      "Stakely is a top Staking-as-a-Service provider specialized in Proof-of-Stake blockchains. With over 40 supported networks, we offer reliable and secure staking services for the best staking experience.\n",
  },
  {
    id: "0x5610297eb32542b8f13378fe7d783dcb1ac3b1a1",
    name: "SenseiNode",
    description:
      "SenseiNode is the first institutional-grade blockchain infrastructure service provider in Latin America. We automate and simplify the deployment and monitoring of nodes on leading protocols, providing access to organizations looking to build their blockchain infrastructure with a high availability and low total cost of ownership.",
  },
  {
    id: "0x089a97a8bc0c0f016f89f9cf42181ff06afb2daf",
    name: "validator service",
    description: "reliable validation",
  },
  {
    id: "0x58c9d90f8fd08203b3ba5dadc8478d223c05e254",
    name: "0x58c9d90f8fd08203b3ba5dadc8478d223c05e254",
    description: null,
  },
  {
    id: "0x0af0a2671bb19d4be5d6c6899ec712341e472d4b",
    name: "Illus Capital",
    description: "Illus Capital Private Staking Vault",
  },
  {
    id: "0x5799be451ee9fddd171c23bf5be86eccfe1f062f",
    name: "Blockdaemon",
    description:
      "Blockdaemon is the most battle-tested node provider for 70+ protocols, allowing for an easy way to receive optimized rewards while minimizing risk and supporting the network.",
  },
  {
    id: "0x4c09bc47db288f998b33cd63bcc1b6ddcce13f33",
    name: "P2P & Tangem",
    description:
      "Collaboration between Tangem and P2P.ORG. Tangem provides secure and user-friendly hardware wallets for managing digital assets. P2P.ORG is a world-leading non-custodial staking provider with the best industry practices and proven expertise.",
  },
  {
    id: "0x05e393ec11d0197a88d84457908edd4ff235f323",
    name: "Stakin by The Tie - No MEV",
    description:
      "Institutional-grade staking services and Web3 infrastructure provider. T&Cs apply, visit our website.",
  },
  {
    id: "0x649955f4189c3921df60e25f58cb1e81070fedb0",
    name: "Stakesaurus SEA Home Nodes",
    description:
      "High availability setup using a network of home-based nodes in Southeast Asia running minority clients by Stakesaurus' community\n\nCentralised infrastructure is detrimental to both the network and your own ETH (e.g., cloud services, data centres). Correlation penalties can wipe out your hard-earned yield in the best case and take a sizeable chunk out of your capital in the worst.\n\nOur solution? A geographically distributed network of home-staking nodes in Singapore and Malaysia (other SEA locations coming soon!) contributed by the Stakesaurus community. This network of uncorrelated nodes acts as a fallback for one another to provide a high-availability staking service.\n\nWe believe in keeping staking operations as simple as possible to minimise tail risk events and security flaws.\n\nStake with this vault to support my efforts in growing the Solo staking community in Asia!",
  },
  {
    id: "0xb46dba422bcf7f113da2eeb41c0e2cc6298d6bba",
    name: "Blockscape Super Early Bird",
    description:
      "Institutional-grade staking for everyone made by Blockscape in Switzerland. As an early staker, you benefit from a lower commission fee of just 4%, while still enjoying the same levels of security and reliability. We are pioneering the distributed validator technology (DVT) in Stakewise with SSV.\nOur unique setup provides highest standards in security and reliability through a distributed DVT setup located in Canada, Germany, Singapore, and France. With more than 10.000 stakers and over $500.000.000 under management, Blockscape is one of the most reliable staking providers in the world.\nMoreover, we offer dedicated vaults for institutions with specific requirements. Reach out to us at: partner@blockscape.network\nor visit https://blockscape.network for more information.",
  },
  {
    id: "0x579684ecef8ea89224f1898d69fdcc820ee12431",
    name: "Blockshard DVT Explorers",
    description:
      "A Distributed Validator Technology (DVT) vault engineered for resilient, non-custodial Ethereum staking.\n\nValidators are operated using SSV and Obol to eliminate single points of failure and enhance operational robustness. The vault exclusively runs Type 2 (0x02) validators, enabling automatic reward compounding and optimizing for higher effective yield over time.\n\nThe infrastructure follows Blockshard’s production-grade standards, with rigorous monitoring and performance oversight.\n\n• 4.5% fee\n• No deposit cap\n\nBuilt for stakers who prioritize fault tolerance, disciplined operations, and long-term infrastructure alignment.",
  },
  {
    id: "0x91211a4965e75152cb549b308f8ba398c3ab337e",
    name: "Verse ETH Staking",
    description:
      "Earn rewards by staking your ETH in the Verse Ecosystem vault",
  },
  {
    id: "0xdbdee04c72a02a740b9f26ada9203582c8a99daf",
    name: "Chorus One - Obol DV vault",
    description:
      'This vault represents a distributed validator cluster , using Obol\'s DV technology to run the validators across multiple nodes. As a staker, you can expect higher uptime, decreased slashing risk, and a meaningful contribution to the decentralization of the Ethereum network.\n\nBy staking with an Obol DV, you automatically participate in the Obol Contributions initiative, contributing 1% of staking rewards to the "1% for Decentralization" retroactive funding model. Your contributions will be tracked and recognized by Obol and can be viewed on our staking dApp, OPUS Pool.',
  },
  {
    id: "0xb0fd1783826ce1a254ba8d5c409b267238faa9cd",
    name: "CommonWealth",
    description:
      "Professional setup powered by minority pairs and validator client strategies.\nCompetitive 3.9% operator fee.",
  },
  {
    id: "0x4e0a83509f5d0ef2e55b6f08dbf2462b72bcd30a",
    name: "Solo Staker",
    description: "Staking forever",
  },
  {
    id: "0x3f2f7424074bac9337ddca38e83e1518436e0ed0",
    name: "Meria",
    description:
      "Meria is an institutionnal-grade staking service provider. We operate blockchain infrastructure on over +30 networks, all managed by a team of experienced node operators",
  },
  {
    id: "0x3102b4013cb506481e959c8f4500b994d2bff22e",
    name: "brazilpracima",
    description: "Independent Ethereum node operator since genesis",
  },
  {
    id: "0xd21b6bc0a1434aef8cf468a20bf2daefcaf6eab9",
    name: "Caliber",
    description:
      "Caliber is a Web3 Venture Builder empowering founders to build impactful startups. We offer comprehensive support - from funding and engineering to strategy and legal - to drive innovation in consumer apps, DeFi, and infrastructure.",
  },
  {
    id: "0x2ca762ed936e48c23b8a32403dd754020b07e86f",
    name: "VincentTaglia.eth",
    description:
      "Independent Ethereum validator utilizing Nethermind+Teku, uncensored MEV relays, owned hardware, and the smoothing pool. Support decentralization and spread risk by staking with me. Learn more: https://vincenttaglia.eth.limo",
  },
  {
    id: "0x30c13e93c170885e9969ae2e4ff5f020807e0d74",
    name: "Simply Staking: Premium",
    description:
      "Minimum Fee - Unrestricted Maximum MEV - Zero-Cloud - Private Datacentre - 24/7 Engineering Support - All included in Simply Staking's Premium Vault...\n\n\n- Fee: Competitive 3.75%.\n- MEV: Extensive list of MEV relays, free of restrictions, with the ultimate goal of using a global set of relays to maximise profit.\n- Private Data Centre Operation: Your ETH is securely managed in our privately operated data center in Malta, prioritising security and reliability, free from the dependencies of cloud services.",
  },
  {
    id: "0xcf8357e5d8d90aa3c86eeba3c494947dab28bfaf",
    name: "GlobalStake",
    description:
      "With decades of infrastructure experience, GlobalStake's enterprise-grade Web3 data centers, equipment, and protocols are specifically engineered to secure Proof-of-Stake networks. We believe that if you are going to do something, do it right!",
  },
  {
    id: "0xea6db44b0d7e20f72f2b4b3deaaa9e710e718bd9",
    name: "DSRV",
    description:
      "DSRV is an integrated blockchain solutions company with the mission of enriching the crypto ecosystem via stronger connectivity. We strive to be your gateway to a suite of all-comprehensive blockchain services. Everything distributed, served complete.",
  },
  {
    id: "0xa071d03d96554e185a86ab178ea3d76c9caaaad8",
    name: "0xa071d03d96554e185a86ab178ea3d76c9caaaad8",
    description: null,
  },
] as const
